import './../vendors/iziModal';
import Cookies from 'js-cookie';
import '../vendors/jquery.easydropdown';

let fundsHomeForm = document.querySelector('[funds-auth-form]');

if(fundsHomeForm){
    
    let countrySelect = document.getElementById('home_select_country');
    let investorSelect = document.getElementById('home_select_investor')

    let notEmpty = ( elem ) => {
        if( !elem ) return;

        let elementLabel = document.querySelector( 'label[for="'+ elem.id +'"]' );

        if( elem.value == '' ){
            elementLabel.classList.add('error');
            return;
        }
        return true;
    }

    fundsHomeForm.addEventListener('submit', (e)=>{
        e.preventDefault();

        if( notEmpty( countrySelect ) && notEmpty( investorSelect ) ){
            let modal = document.getElementById(`modal`);
            $(modal).iziModal('open');
            
        }
    })

    /**
     * Set coockies on acception
     */    
    document.getElementById('modal').addEventListener('click', event => {
        event.preventDefault();
        
        if( event.target.hasAttribute('funds-auth-accept') ) {
           
            let expiration_days;
            expiration_days = 0.0208;
			

            let country = document.querySelector('[funds-auth-country]');
            let investor = document.querySelector('[funds-auth-investor]');
                    
            if( !country || !investor ) return;

            let countryID = country.value;
            let investorID = investor.value;

            Cookies.set('funds_auth_investor', investorID, { expires: expiration_days });
			Cookies.set('funds_auth_country', countryID, { expires: expiration_days });
			
			window.location = event.target.href;
        }
    });

	/**
	 * Show Sorry messages
	 */
	let sorryMsg = document.querySelector('[funds-auth-exception]');

	/**
	 * activate no-auth mode
	 */
	let activateNoAuthMode = ( elem )=>{
		let label = document.querySelector( 'label[for="'+ elem.id +'"]' );
		let btn = fundsHomeForm.querySelector('button[type="submit"]');
		label.classList.add('no-auth-mode');
		if ( btn ) btn.disabled = true;
		if ( sorryMsg ) $( sorryMsg ).slideDown();
	}

	/**
	 * activate no-auth mode
	 */
	let deactivateNoAuthMode = ( elem )=>{
		let label = document.querySelector( 'label[for="'+ elem.id +'"]' );
		let btn = fundsHomeForm.querySelector('button[type="submit"]');
		label.classList.remove('no-auth-mode');
		if( btn ) btn.disabled = false;
		if( sorryMsg ) $( sorryMsg ).slideUp();
	}

	/**
	 * init easyDropdown for countries select
	 */
	let countryDropdown = $(countrySelect).easyDropDown({
		cutOff: 6,
		onChange: (selected) => {
			if ( !countrySelect ) return;
			let currentOption = countrySelect.options[countrySelect.selectedIndex];

			let totalSubfunds = ( currentOption && currentOption.dataset.totalSubfunds ) ? currentOption.dataset.totalSubfunds : '';

			if( totalSubfunds === '0' ) activateNoAuthMode( countrySelect );
			else deactivateNoAuthMode( countrySelect );

			// remove error css class from label related to select
			if(selected.value != '' && selected.value != ''){
				let elementLabel = document.querySelector( 'label[for="'+ countrySelect.id +'"]' );

				if( elementLabel ){
					elementLabel.classList.remove('error');
					return;
				}
			}
		}
	});

	/**
	 * init easyDropdown for investors select
	 */
	let investorDropdown = $(investorSelect).easyDropDown({
		cutOff: 6,
		onChange: function(selected){
		
			// remove error css class from label related to select
			if(selected.value != ''){
				let elementLabel = document.querySelector( 'label[for="'+ this.id +'"]' );

				if( elementLabel ){
					elementLabel.classList.remove('error');
					return;
				}
			}
		}
	});
}
 


// WEBPACK FOOTER //
// ./scripts/modules/funds-homepage-form.js